import ReactValidator from "legacy/ReactValidator.es6"
import NextButton from "legacy/boater-reservation-flow/NextButton"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

class PlaceholderModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      processing: false,
      processingDelete: false,
      start_date: this.newElseEdit()
        ? moment(this.props.state.night).format("L")
        : moment(this.props.state.editPlaceholder.start_date).format("L"),
      end_date: this.newElseEdit()
        ? moment(this.props.state.night).format("L")
        : moment(this.props.state.editPlaceholder.end_date).format("L"),
      note: this.newElseEdit() ? "" : this.props.state.editPlaceholder.note,
    }
    this.validator = new ReactValidator()
    this.newElseEdit = this.newElseEdit.bind(this)
    this.savePlaceholder = this.savePlaceholder.bind(this)
    this.deletePlaceholder = this.deletePlaceholder.bind(this)
    this.reloadPageData = this.reloadPageData.bind(this)
    this.title = this.title.bind(this)
    this.setStartDate = this.setStartDate.bind(this)
    this.setEndDate = this.setEndDate.bind(this)
    this.setNote = this.setNote.bind(this)

    this.startDate = null
    this.setStartDateElementRef = (element) => {
      this.startDate = element
    }

    this.endDate = null
    this.setEndDateElementRef = (element) => {
      this.endDate = element
    }
  }

  componentDidMount() {
    // Initialize datepickers
    $(this.startDate)
      .datepicker()
      .on("changeDate", (e) => {
        this.setState({ start_date: this.startDate.value })
      })
    $(this.endDate)
      .datepicker()
      .on("changeDate", (e) => {
        this.setState({ end_date: this.endDate.value })
      })
  }

  newElseEdit() {
    return this.props.state.newPlaceholderForSpace !== null
  }

  savePlaceholder() {
    this.validator.displayErrors()
    if (this.validator.allValid() === true) {
      this.setState({ processing: true })
      const postData = {
        start_date: this.state.start_date,
        end_date: this.state.end_date,
        note: this.state.note,
      }
      if (this.newElseEdit()) {
        postData.space_id = this.props.state.newPlaceholderForSpace.id
      } else {
        postData.space_note_id = this.props.state.editPlaceholder.id
      }
      $.post(
        "/manage/" + this.props.state.marinaSlug + "/space_notes/upsert",
        postData,
        (data) => {
          this.reloadPageData()
        }
      )
    }
  }

  deletePlaceholder() {
    this.setState({ processingDelete: true })
    $.post(
      "/manage/" + this.props.state.marinaSlug + "/space_notes/delete",
      { space_note_id: this.props.state.editPlaceholder.id },
      (data) => {
        this.reloadPageData()
      }
    )
  }

  reloadPageData() {
    this.props.loadPageData(() => {
      this.setState({ processing: false, processingDelete: false })
      this.props.handleHidePlaceholderModal()
    })
  }

  title() {
    return this.newElseEdit()
      ? "New Placeholder for " + this.props.state.newPlaceholderForSpace.name
      : "Edit Placeholder for " + this.props.state.editPlaceholder.space_name
  }

  setStartDate() {
    // values are set in the onchange in the componentDidMount method
  }

  setEndDate() {}

  setNote(e) {
    this.setState({ note: e.target.value })
  }

  render() {
    return (
      <Modal
        isOpen={true}
        onClose={this.props.handleHidePlaceholderModal}
        size="mediumFixed"
      >
        <Modal.Header title={this.title()} />
        <Modal.Body>
          <div className="row nested-row">
            <div className="col-sm-6">
              <div className="form-group">
                <label>Start Date</label>
                <div className="form-control-with-icon">
                  <i className="icon icon-calendar form-control-icon-left" />
                  <input
                    className="form-control datepicker"
                    ref={this.setStartDateElementRef}
                    type="text"
                    onChange={this.setStartDate}
                    placeholder="mm/dd/yyyy"
                    value={this.state.start_date}
                    data-provide="datepicker"
                    name="date"
                    data-date-orientation="top"
                    data-date-autoclose="true"
                    data-date-disable-touch-keyboard="true"
                  />
                  {this.validator.message(
                    "start_date",
                    this.state.start_date,
                    "required"
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <label>End Date</label>
                <div className="form-control-with-icon">
                  <i className="icon icon-calendar form-control-icon-left" />
                  <input
                    className="form-control datepicker"
                    ref={this.setEndDateElementRef}
                    type="text"
                    onChange={this.setEndDate}
                    placeholder="mm/dd/yyyy"
                    value={this.state.end_date}
                    data-provide="datepicker"
                    name="date"
                    data-date-orientation="top"
                    data-date-autoclose="true"
                    data-date-disable-touch-keyboard="true"
                  />
                  {this.validator.message(
                    "end_date",
                    this.state.end_date,
                    "required"
                  )}
                </div>
              </div>
            </div>
          </div>
          <label htmlFor="placeholder-note">Placeholder Note</label>
          <textarea
            id="placeholder-note"
            className="form-control"
            value={this.state.note}
            onChange={this.setNote}
          />
          {this.validator.message("note", this.state.note, "required")}
        </Modal.Body>
        <Modal.Footer>
          <div className="flex justify-between">
            {!this.newElseEdit() && (
              <NextButton
                processing={this.state.processingDelete}
                click={this.deletePlaceholder}
                icon=""
                btnClass="btn-danger"
                text="Delete"
                processingText="Deleting..."
              />
            )}
            <div className="ml-auto flex space-x-2">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={this.props.handleHidePlaceholderModal}
                style={{ width: "70px" }}
              >
                Cancel
              </button>
              <NextButton
                processing={this.state.processing}
                click={this.savePlaceholder}
                icon=""
                text="Save"
                processingText="Saving..."
              />
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}

PlaceholderModal.propTypes = {
  state: PropTypes.shape({
    night: PropTypes.string.isRequired,
    marinaSlug: PropTypes.string.isRequired,
    newPlaceholderForSpace: PropTypes.object,
    editPlaceholder: PropTypes.object,
  }).isRequired,
  handleHidePlaceholderModal: PropTypes.func.isRequired,
  loadPageData: PropTypes.func.isRequired,
  controller: PropTypes.object,
}

export default PlaceholderModal
